import { render } from "./projectext2.vue?vue&type=template&id=38c91b2e&scoped=true"
import script from "./projectext2.vue?vue&type=script&lang=js"
export * from "./projectext2.vue?vue&type=script&lang=js"

import "./projectext2.vue?vue&type=style&index=0&id=38c91b2e&scoped=true&lang=css"

import exportComponent from "G:\\zhongfu\\web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38c91b2e"]])

export default __exports__